export class MissingConfigPropsError extends Error {
  constructor(missingProps: string[]) {
    super(
      `Template compiler is missing the following config props: ${missingProps}`,
    );
    Object.setPrototypeOf(this, MissingConfigPropsError.prototype);
    this.name = 'MissingConfigPropsError';
  }
}
